import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource/inter/400.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
// Optional display/body fonts for the Design Constructor typography editor.
// They load only the weights actually used by DS components/templates.
import '@fontsource/reddit-sans-condensed/400.css';
import '@fontsource/reddit-sans-condensed/600.css';
import '@fontsource/reddit-sans-condensed/700.css';
import '@fontsource/reddit-sans-condensed/800.css';
import '@fontsource/figtree/400.css';
import '@fontsource/figtree/600.css';
import '@fontsource/figtree/700.css';
// Bebas Neue ships only a single weight (400) — it's a display face,
// uppercase-only by convention. Used by WinnerBadgeBackdrop for the
// huge background badge name; available as an option in FONT_FAMILIES.
import '@fontsource/bebas-neue/400.css';
// Khand — condensed display face (weights 300–700); a heading option in the
// Design Constructor. Load the weights DS components/templates may use.
import '@fontsource/khand/400.css';
import '@fontsource/khand/500.css';
import '@fontsource/khand/600.css';
import '@fontsource/khand/700.css';
// Press Start 2P — single-weight (400) pixel/arcade display face. Uppercase,
// chunky; a display option in the Design Constructor.
import '@fontsource/press-start-2p/400.css';
// Sora — geometric sans (weights 100–800); a body/heading option in the
// Design Constructor. Load the weights DS components/templates may use.
import '@fontsource/sora/400.css';
import '@fontsource/sora/600.css';
import '@fontsource/sora/700.css';
import '@fontsource/sora/800.css';
import { App } from './App';
import { captureAttributionFromURL } from './modules/attribution';
import './index.css';

// Affiliate link params (?ref=&clickId=) exist only on the landing URL: keep
// them before the app rewrites it, so a later registration can send them.
captureAttributionFromURL(window.location.href);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element not found');
createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
